// extracted by mini-css-extract-plugin
export default {"container":"PostCardLayout_container__FdUm1"};